import { styled } from 'styled-components'

export const P = styled.p`
    position : relative;
    display : flex;
    justify-content : center;
    flex-direction : column;
    align-items : center;
    color : #7F8080;
    font-size : 1.8rem;

    svg {
        display : block;
        width : 50px;
        height : 50px;
        margin-bottom : 30px;
    }
`